import React, { useEffect, useState, useRef } from "react";
import { Marker, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";

const SiteMarker = ({ position, site, onMarkerClick, type }) => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  const markerRef = useRef();

  useEffect(() => {
    if (markerRef.current) {
      const leafletMarker = markerRef.current;
      const tooltip = leafletMarker.getTooltip();
      if (tooltip) {
        if (zoom > 11) {
          tooltip.setLatLng(leafletMarker.getLatLng());
          if (!tooltip.isOpen()) {
            leafletMarker.openTooltip();
          }
        } else {
          if (tooltip.isOpen()) {
            leafletMarker.closeTooltip();
          }
        }
      }
    }
  }, [zoom]);

  useEffect(() => {
    if (markerRef.current && zoom > 11) {
      const leafletMarker = markerRef.current;
      const maintainTooltip = () => {
        const tooltip = leafletMarker.getTooltip();
        if (tooltip && !tooltip.isOpen()) {
          leafletMarker.openTooltip();
        }
      };
      map.on("click", maintainTooltip);
      return () => {
        map.off("click", maintainTooltip);
      };
    }
  }, [zoom, map]);

  useEffect(() => {
    const updateZoom = () => {
      setZoom(map.getZoom());
    };
    map.on("zoom", updateZoom);
    return () => {
      map.off("zoom", updateZoom);
    };
  }, [map]);

  const iconMarkup = `
    <div>
      <div class="site-pulse-dot ${type}"></div>
      <div class="site-pulse-ring ${type}"></div>
      <div class="site-pulse-ring ${type}"></div>
    </div>
  `;

  const customIcon = L.divIcon({
    className: "custom-div-icon",
    html: iconMarkup,
    iconSize: [50, 50],
    iconAnchor: [25, 25],
  });

  return (
    <Marker
      ref={markerRef}
      position={{
        lat: position.latitude,
        lng: position.longitude,
      }}
      icon={customIcon}
      eventHandlers={{
        click: () => onMarkerClick(site),
      }}
    >
      <Tooltip
        direction="top"
        offset={[0, -15]}
        opacity={1}
        permanent={zoom > 11}
        interactive={false}
        key={`tooltip-${zoom > 11 ? "permanent" : "hover"}`}
      >
        <strong className="m-0">{site.name}</strong>
      </Tooltip>
    </Marker>
  );
};

export default SiteMarker;
